//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'layout',
  components: {
  },
  computed: {
  },
    data() {
        return {
            companyName: '',
        }
    },
    mounted() {
        const axios = require('axios');
        var companyId = this.$auth.user.companyId
        var url = "https://api.eezywork.nl/v1/companies/read.php?companyId="+companyId;
        axios.get(url)
        .then(response => {
            this.companyName = response.data[0].name;
            // console.log(this.companyName)
        })
        .catch(error => {
            // console.log(error.response)
        });
    },
  methods: {
    startLoading(){
      this.$refs.sidebar.startLoading();
    },
    endLoading(){
      this.$refs.sidebar.endLoading();	
    }
  }
}
